import React, { useState, useRef } from 'react';
import { Box, Text, TextInput, Footer, Sidebar } from 'grommet';
import { Hpe as HpeIcon, Send as SendIcon } from 'grommet-icons';
import { useHeaderHeight } from '../utils/HeaderHeightContext'; // Import the hook

export const AgentSidebar = ({ isAgentExpanded }) => {
  const [value, setValue] = useState('');
  const sidebarRef = useRef(null);
  const { headerHeight } = useHeaderHeight(); // Get headerHeight from context

  return (
    <Box background="background-back">
      <Box
        direction="row"
        background="background-back"
        elevation="medium"
        margin="0"
        style={{ height: `calc(100vh - ${headerHeight}px - 8px)` }} // Use headerHeight from context
      >
        <Sidebar
          ref={sidebarRef}
          background="background-back"
          width={isAgentExpanded ? "medium" : "0"}  // Adjust width based on the expanded state
          pad={{ top: 'none', bottom: '5px', right: 'none', left: 'none' }}
          align="start"
          gap="small"
          style={{
            transition: 'width 0.3s ease-in-out', // Smooth transition for sidebar width
            overflow: 'auto', // Allow content to scroll if it overflows
          }}
        >
          {isAgentExpanded && (
            <Box background="background-back" elevation="medium" flex width="100%" align="stretch" style={{ height: 'auto' }} >
              {/* Agent content displayed when expanded */}
              <Box flex justify="center">
                <Box direction="row" justify="center">
                  <HpeIcon color="brand" alignSelf="center" />
                </Box>

                <Box direction="row" justify="center" margin={{ left: "20px", right: "20px" }}>
                  <Text size="20pt" textAlign="center" style={{ fontWeight: 'bold' }}>
                    Hello, I'm Lucia your Explorer Agent. How can I help you today?
                  </Text>
                </Box>

                <Box direction="row" justify="center" margin={{ top: "15px", bottom: "5px", left: "20px", right: "20px" }}>
                  <TextInput
                    placeholder="Message Lucia (coming soon)..."
                    icon={<SendIcon id="send-icon" />}
                    reverse
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                  />
                </Box>

                <Box direction="row" justify="center">
                  <Text size="10pt">AI-Generated content may be inaccurate.{ headerHeight }</Text>
                </Box>
              </Box>

              <Footer pad="small" justify="center">
                <Text size="11pt" style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                  Powered by HPE IT & PCAI
                </Text>
              </Footer>
            </Box>
          )}
        </Sidebar>
      </Box>
    </Box>
  );
};




